import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import Input from '@components/Input';
import CleanIcon from '@components/CleanIcon';

import messages from './messages';

const PLACEHOLDER = 'DD/MM/AAAA';
const REGEX_FORMAT = /([^0-9]|\/)/;

const formatInputFn = value => {
  const [day, firstSlash, month, secondSlash, year] = value.split(REGEX_FORMAT);
  if (day && month && year) return value;

  const addSlash = (val, slash) => (val?.length === 2 || slash ? '/' : '');

  const dayPart = `${day}${addSlash(day, firstSlash)}`;
  const monthPart = `${month || ''}${addSlash(month, secondSlash)}`;
  return `${dayPart}${monthPart}${year || ''}`;
};

function DateInput({
  elementId,
  label,
  value,
  onChange,
  onClean,
  showErrorMessage,
  autoFocus,
  errorMessage,
  intl: { formatMessage },
}) {
  const onChangeValue = useCallback(
    newValue => {
      if (newValue.length > value.length) onChange(formatInputFn(newValue));
      else onChange(newValue);
    },
    [onChange, value],
  );

  const inputIcon = value ? <CleanIcon onClick={onClean} /> : null;

  return (
    <Input
      type="text"
      label={label}
      value={value}
      elementId={elementId}
      onChange={onChangeValue}
      onClean={onClean}
      placeholder={PLACEHOLDER}
      iconToShow={inputIcon}
      errorMessage={errorMessage || formatMessage(messages.dateInput)}
      showErrorMessage={showErrorMessage}
      maxLength="10"
      pattern="\d*"
      showErrorAlways
      autoFocus={autoFocus}
    />
  );
}

DateInput.propTypes = {
  // data
  elementId: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  showErrorMessage: PropTypes.bool,
  autoFocus: PropTypes.bool,
  errorMessage: PropTypes.string,

  // callbacks
  onChange: PropTypes.func.isRequired,
  onClean: PropTypes.func.isRequired,
  intl: intlShape,
};

DateInput.defaultProps = {
  showErrorMessage: false,
  autoFocus: true,
};

export default injectIntl(DateInput);
